/**
 * Gate cart checkout behind Terms & Conditions acceptance.
 * Uses event delegation so drawer / section re-renders stay wired.
 */
(function () {
  const CHECKBOX_SEL = '[data-cart-terms-checkbox]';
  const BUTTON_SEL = '[data-cart-terms-checkout]';
  let syncScheduled = false;

  function findCheckboxForButton(button) {
    if (button.form) {
      const inForm = button.form.querySelector(CHECKBOX_SEL);
      if (inForm) return inForm;
    }

    const formId = button.getAttribute('form');
    if (formId) {
      const associated = document.querySelector(`${CHECKBOX_SEL}[form="${formId}"]`);
      if (associated) return associated;
    }

    const panel = button.closest('.spec-panel__actions, .cart-drawer__summary');
    if (panel) {
      const local = panel.querySelector(CHECKBOX_SEL);
      if (local) return local;
    }

    return document.querySelector(CHECKBOX_SEL);
  }

  function syncCheckoutButtons() {
    document.querySelectorAll(BUTTON_SEL).forEach((button) => {
      if (button.dataset.cartEmpty === 'true') {
        if (!button.disabled) button.disabled = true;
        return;
      }

      const checkbox = findCheckboxForButton(button);
      const accepted = Boolean(checkbox?.checked);
      const shouldDisable = !accepted;
      if (button.disabled !== shouldDisable) {
        button.disabled = shouldDisable;
      }
    });
  }

  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    requestAnimationFrame(() => {
      syncScheduled = false;
      syncCheckoutButtons();
    });
  }

  function onChange(event) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.matches(CHECKBOX_SEL)) return;
    syncCheckoutButtons();
  }

  function onSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const checkbox =
      form.querySelector(CHECKBOX_SEL) ||
      (form.id ? document.querySelector(`${CHECKBOX_SEL}[form="${form.id}"]`) : null);

    if (!checkbox) return;
    if (checkbox.checked) return;

    event.preventDefault();
    checkbox.focus();
    syncCheckoutButtons();
  }

  document.addEventListener('change', onChange);
  document.addEventListener('submit', onSubmit, true);
  document.addEventListener('cart:update', scheduleSync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCheckoutButtons);
  } else {
    syncCheckoutButtons();
  }

  // Re-sync when cart drawer / summary markup is replaced (without attribute thrash loops).
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== 'childList') continue;
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (
          node.matches?.(CHECKBOX_SEL) ||
          node.matches?.(BUTTON_SEL) ||
          node.querySelector?.(CHECKBOX_SEL) ||
          node.querySelector?.(BUTTON_SEL)
        ) {
          scheduleSync();
          return;
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
